const topTrechosSamaturpassagens = [
    {
        idCidadeOrigem: 2498,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 304,
        nomeCidadeDestinoComUF: 'Barra do Corda-MA',
        nomeCidadeDestinoComUFNormalizado: 'barradocorda-ma',
        ordem: 1
    },
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 347,
        nomeCidadeDestinoComUF: 'Estreito-MA',
        nomeCidadeDestinoComUFNormalizado: 'estreito-ma',
        ordem: 2
    },        
    {
        idCidadeOrigem: 304,
        nomeCidadeOrigemComUF: 'Barra do Corda-MA',
        nomeCidadeOrigemComUFNormalizado: 'barradocorda-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 3
    },    
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 376,
        nomeCidadeDestinoComUF: 'Lago da Pedra-MA',
        nomeCidadeDestinoComUFNormalizado: 'lagodapedra-ma',
        ordem: 4
    },
    {
        idCidadeOrigem: 362,
        nomeCidadeOrigemComUF: 'Grajaú-MA',
        nomeCidadeOrigemComUFNormalizado: 'grajau-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 5
    },
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 427,
        nomeCidadeDestinoComUF: 'Presidente Dutra-MA',
        nomeCidadeDestinoComUFNormalizado: 'presidentedutra-ma',
        ordem: 6
    },
    {
        idCidadeOrigem: 376,
        nomeCidadeOrigemComUF: 'Lago da Pedra-MA',
        nomeCidadeOrigemComUFNormalizado: 'lagodapedra-ma',
        idCidadeDestino: 1,
        nomeCidadeDestinoComUF: 'Brasília-DF',
        nomeCidadeDestinoComUFNormalizado: 'brasilia-df',
        ordem: 7
    },
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 339,
        nomeCidadeDestinoComUF: 'Colinas-MA',
        nomeCidadeDestinoComUFNormalizado: 'colinas-ma',
        ordem: 8
    },
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 468,
        nomeCidadeDestinoComUF: 'São Raimundo das Mangabeiras-MA',
        nomeCidadeDestinoComUFNormalizado: 'saoraimundodasmangabeiras-ma',
        ordem: 9
    },
    {
        idCidadeOrigem: 468,
        nomeCidadeOrigemComUF: 'São Raimundo das Mangabeiras-MA',
        nomeCidadeOrigemComUFNormalizado: 'saoraimundodasmangabeiras-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 10
    },    
    {
        idCidadeOrigem: 328,
        nomeCidadeOrigemComUF: 'Carolina-MA',
        nomeCidadeOrigemComUFNormalizado: 'carolina-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 11
    },
    {
        idCidadeOrigem: 409,
        nomeCidadeOrigemComUF: 'Paraibano-MA',
        nomeCidadeOrigemComUFNormalizado: 'paraibano-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 12
    },
    {
        idCidadeOrigem: 427,
        nomeCidadeOrigemComUF: 'Presidente Dutra-MA',
        nomeCidadeOrigemComUFNormalizado: 'presidentedutra-ma',
        idCidadeDestino: 3,
        nomeCidadeDestinoComUF: 'Taguatinga-DF',
        nomeCidadeDestinoComUFNormalizado: 'taguatinga-df',
        ordem: 13
    },
    {
        idCidadeOrigem: 3,
        nomeCidadeOrigemComUF: 'Taguatinga-DF',
        nomeCidadeOrigemComUFNormalizado: 'taguatinga-df',
        idCidadeDestino: 378,
        nomeCidadeDestinoComUF: 'Lago dos Rodrigues',
        nomeCidadeDestinoComUFNormalizado: 'lagodosrodrigues-ma',
        ordem: 14
    },
    {
        idCidadeOrigem: 1,
        nomeCidadeOrigemComUF: 'Brasília-DF',
        nomeCidadeOrigemComUFNormalizado: 'brasilia-df',
        idCidadeDestino: 328,
        nomeCidadeDestinoComUF: 'Carolina-MA',
        nomeCidadeDestinoComUFNormalizado: 'carolina-mara',
        ordem: 15
    },
]

export default topTrechosSamaturpassagens;